import React, { useEffect, useRef, useState } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { setMinutes, setHours, isBefore } from 'date-fns';

function CustomDatePicker(props: any) {
    const handleDatePicker: any = useRef();
    const [show, setShow] = useState(false);
    const [inputVal, setInputVal] = useState('');
    const [error, setError] = useState(false);
    const [errorMsg, setErrorMsg] = useState('');
    const currentDate = new Date();

    const hasTimeComponent = date => {
        return date.getHours() !== 0 || date.getMinutes() !== 0 || date.getSeconds() !== 0;
    };

    const validate = (dateD: any) => {
        try {
            let data: any = dateD;
            if (hasTimeComponent(dateD)) {
                data = new Date(dateD);
            } else {
                let givenDate: any = new Date(data);
                const currentTime = new Date();
                let hr = currentTime.getHours();
                let mn = currentTime.getMinutes();
                let sc = currentTime.getSeconds();

                if (props.dtype == 'demand_cutoff_date') {
                    hr = hr + 2;
                    mn = mn + 15;
                } else if (props.dtype == 'demand_pickupdate' && isBefore(dateD, props.selectDate)) {
                    givenDate = new Date(props.selectDate);
                    hr = givenDate.getHours() + 2;
                    mn = givenDate.getMinutes() + 15;
                    sc = givenDate.getSeconds();
                } else if (props.dtype == 'demand_delivery_date' && isBefore(dateD, props.selectDate)) {
                    givenDate = new Date(props.selectDate);
                    hr = givenDate.getHours() + 2;
                    mn = givenDate.getMinutes() + 15;
                    sc = givenDate.getSeconds();
                }

                givenDate.setHours(hr);
                givenDate.setMinutes(mn);
                givenDate.setSeconds(sc);
                // console.log('givenDate', props.dtype, dateD, givenDate, isBefore(dateD, props.selectDate));

                data = givenDate;
            }

            if (data?.length == 0 || data == null) {
                if (props?.inputProps?.[props.controlName]?.required) {
                    // setErrorMsg('Date and time cannot be in past ');
                    setErrorMsg(props?.errorMsg);
                    hideShowError(true);
                }

                props.setValue({ [props.controlName]: props?.inputProps?.[props.controlName]?.required ? null : '' });
            } else if (props?.inputProps?.[props.controlName]?.pattern) {
                const regmob = new RegExp(props?.inputProps?.[props.controlName]?.pattern);
                if (!regmob.test(data)) {
                    setErrorMsg('Invalid Data'); //`${props?.data.name} is invalid. Please enter valid data`
                    props.setValue({
                        [props.controlName]: props?.inputProps?.[props.controlName]?.required ? null : '',
                    });
                    hideShowError(true);
                } else {
                    setErrorMsg('');
                    hideShowError(false);
                    props.setValue({ [props.controlName]: data });
                }
            }
            // else if (props.fromType == "demand" && new Date().getTime() > new Date(data).getTime() && data != null && props.date == undefined) {
            //     setErrorMsg('Date and time cannot be in past ');
            //     hideShowError(true);
            //     setInputVal(null);
            //     return false;
            // }
            else {
                hideShowError(false);
                props.setValue({ [props.controlName]: data });
            }

            setInputVal(data);
        } catch (error) {
            console.log('error', error);
        }
    };

    useEffect(() => {
        try {
            if (!show) {
                setShow(props.isSubmit);
            }
            const d = props?.value?.toString() || inputVal ? props?.value?.toString() || inputVal.toString() : '';
            const data = { [props.controlName]: props?.inputProps?.[props.controlName]?.required ? (d ? d : null) : d };
            props.setValue(data);
            const inputValStr = inputVal ? inputVal.toString() : '';

            if (inputValStr?.length > 0) {

                setError(checkInputVali());
            }
        } catch (error) {
            console.log('error', error);
        }
    }, [props.isSubmit]);

    const checkInputVali = () => {
        if (props?.inputProps?.[props.controlName]?.pattern) {
            const regmob = new RegExp(props?.inputProps?.[props.controlName]?.pattern);
            if (!regmob.test(inputVal)) {
                return true;
            } else {
                return false;
            }
        } else {
            return false;
        }
    };

    useEffect(() => {
        setData();
    }, [props.inputProps]);

    useEffect(() => {
        if (props?.value) {
            setInputVal(new Date(props?.value || ''));
        }

        setData();
    }, [props.forceRender]);

    const setData = () => {
        try {
            const erMsg = props?.inputProps?.[props.controlName]?.message || null;
            setErrorMsg(erMsg);
            setError(props?.inputProps?.[props.controlName]?.error);
        } catch (error) { }
    };

    useEffect(() => {
        if (props.makeEmpty && props?.value) {
            const valDate = new Date(props?.value);
            setInputVal(valDate || null);
            setError(true);
        } else if (props.makeEmpty) {
            setInputVal(null);
            setError(true);
            if (props.isSubmit) {
                hideShowError(true);
            }
        }
    }, [props?.value]);

    const hideShowError = (flag: boolean) => {
        try {
            setShow(flag);
            setError(flag);
        } catch (error) { }
    };

    const toggle = () => {
        try {
            handleDatePicker.current.toggleCalendar();
        } catch (error) { }
    };

    return (
        <React.Fragment>
            {/* <div>
                {error ? 'true' : 'false'} {show ? 'true' : 'false'}
            </div> */}
            {/* {props?.options?.length} */}
            <div className="form-group">
                <div className="form-floating custom_floating_box">
                    <DatePicker
                        ref={handleDatePicker}
                        toggleCalendarOnIconClick
                        disabled={props.disabled ? true : false}
                        selected={inputVal}
                        onChange={e => {
                            validate(e);
                            if (!props.closeOnSelect && e.target) {
                                e.target.blur();
                            }

                            // setInputVal(e || null);
                        }}
                        autoComplete="off"
                        className={`form-control custom-datepicker`}
                        controlName={props?.controlName}
                        showTimeSelect={props.showTimeSelect == false ? false : true}
                        minDate={props.minDate ? new Date(props.minDate) : new Date()}
                        maxDate={props.maxDate ? new Date(props.maxDate) : null}
                        highlightDates={currentDate}
                        // readOnly
                        // minTime={props.minDate ? new Date(props.minDate) : new Date()}
                        // maxTime={setHours(setMinutes(new Date(), 45), 23)}
                        dateFormat={props.showTimeSelect == false ? 'dd-MM-yyyy' : 'dd-MM-yyyy h:mm aa'}
                        timeFormat="h:mm aa"
                        timeIntervals={15}
                        id={props.data?.id}
                        name={props.name}
                        placeholderText={props.data.placeholder}
                        {...props.inputProps} // Pass the rest of the inputProps to DatePicker
                        filterTime={props?.filterPassedTime}
                        customInput={<input inputMode="none" readOnly />}
                        onFocus={e => e.target.blur()}
                    />
                    <label className="labeltext" htmlFor="floatingInput">
                        {props.data.label}
                        <sup className="text-red">*</sup>
                    </label>
                    <div className="input-group-addon passview" onClick={() => toggle()}>
                        <i className={`fa fa-calendar`} aria-hidden="true"></i>
                    </div>

                    {error && show && (
                        <div className="text-danger ft-12" style={{ marginLeft: '20px' }}>
                            {' '}
                            {errorMsg || 'Field is required'}
                        </div>
                    )}
                </div>
            </div>
        </React.Fragment>
    );
}

export default CustomDatePicker;